import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import TrueLinkButton from 'react/shared/components/true_link/main/TrueLinkButton';
import CardText from 'react/shared/components/true_link/main/form/wizard/CardText';
import theme, { mediumBreakpointMediaQuery } from 'react/shared/theme/Theme';
import PALETTE from 'react/shared/theme/palette';
import { oneLineAddress } from 'react/shared/utils/Address';
import addressShape from 'react/signups/card/shapes/AddressShape';
import shippingDestinationShape from 'react/signups/card/shapes/ShippingDestination';

const useStyles = makeStyles(() => ({
  borderlessGrid: {
    marginBottom: '10px',
  },
  grid: {
    borderBottom: `1px solid ${PALETTE.grey5}`,
    paddingBottom: '10px',
    marginBottom: '10px',
  },
  buttons: {
    justifyContent: 'flex-end',
  },
  buttonsMobile: {
    justifyContent: 'center',
    paddingTop: theme.spacing(1),
  },
}));

export default function EditableAddress({ address, name, onEdit, onSelect, shippingDestination }) {
  const classes = useStyles();
  const desktop = useMediaQuery(mediumBreakpointMediaQuery);

  const gridClass = onSelect ? classes.grid : classes.borderlessGrid;

  const handleSelect = () => {
    onSelect({ address }, shippingDestination);
  };

  const handleEdit = () => {
    onEdit({ address }, shippingDestination);
  };

  return (
    <Grid alignItems="center" className={gridClass} container justifyContent="space-between">
      <Grid container item md={7} xs={12}>
        <Grid container>
          <Grid container item xs={12}>
            <CardText gutterBottom={false}>{name}</CardText>
          </Grid>
          <Grid container item xs={12}>
            <CardText gutterBottom={false}>{oneLineAddress(address)}</CardText>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        className={desktop ? classes.buttons : classes.buttonsMobile}
        container
        item
        md={5}
        spacing={1}
        xs={12}
      >
        {onSelect && (
          <>
            <Grid item>
              <TrueLinkButton onClick={handleEdit} variant="primaryOutline">
                Edit address
              </TrueLinkButton>
            </Grid>
            <Grid item>
              <TrueLinkButton onClick={handleSelect} variant="primaryOutline">
                Ship here
              </TrueLinkButton>
            </Grid>
          </>
        )}
        {!onSelect && (
          <Grid item>
            <TrueLinkButton onClick={handleEdit} variant="primaryOutline">
              Add new address
            </TrueLinkButton>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

EditableAddress.propTypes = {
  address: addressShape.isRequired,
  name: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  shippingDestination: shippingDestinationShape.isRequired,
};
